
import {
    toast
} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';


//toast.configure();

/**
 * 
 * @param {String} message the toast message to display
 * @param {String} [type] one of the following: "success" | "warning" | "error" | "info" | "default"
 * @param {Object} props all remaining ToastMessage options.
 * @param {Boolean} props.promise activate a promise toast (see docs). If set to true, an additional promiseMessages will need to be supplied.
 * @param {Object} props.promiseMessages an object containing messages to display for a promise toast. contains 3 props: pending, success and error.
 * @param {Object} props.options options to be passed to toast messages
 * @returns toast message
 */
const ToastMessage = (message, type = "default", props = { options: {} }) => {
    const { options } = props;
    if (props.dismiss) return toast.dismiss();
    if (props.promise) {
        return toast.promise(props.callback, props.promiseMessages);
    }
    return toast[type](message, options);
}

export default ToastMessage;

export const renderImportStatus = data => {
    let msg = <div>
        {Array.isArray(data.status) && data.status.map(m => <p>{m.message}</p>)}
        {data.importId && <p>Import Id: {data.importId}</p>}
    </div>
    return msg
}